import React from 'react';
import { BarChart3, Share2, AlertCircle } from 'lucide-react';
import { HeadlineType } from '../types';

interface HeadlineResultsProps {
  headlines: HeadlineType[];
}

export function HeadlineResults({ headlines }: HeadlineResultsProps) {
  const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text);
  };

  return (
    <div className="bg-white rounded-xl shadow-lg p-6">
      <h2 className="text-xl font-semibold text-gray-900 mb-6 flex items-center gap-2">
        <BarChart3 className="text-indigo-600" />
        Generated Headlines
      </h2>
      
      {headlines.length === 0 ? (
        <div className="text-center text-gray-500 py-12">
          <AlertCircle className="w-12 h-12 mx-auto mb-4 opacity-50" />
          <p>Enter your topic and keyword to generate headlines</p>
        </div>
      ) : (
        <div className="space-y-6">
          {headlines.map((headline, index) => (
            <div key={index} className="p-4 border border-gray-200 rounded-lg hover:border-indigo-200 transition-colors duration-200">
              <h3 className="text-lg font-medium text-gray-900 mb-3">{headline.title}</h3>
              <div className="grid grid-cols-4 gap-4 text-sm">
                <div>
                  <div className="text-gray-500">Emotional</div>
                  <div className="font-semibold text-indigo-600">{headline.metrics.emotional}/10</div>
                </div>
                <div>
                  <div className="text-gray-500">Curiosity</div>
                  <div className="font-semibold text-indigo-600">{headline.metrics.curiosity}/10</div>
                </div>
                <div>
                  <div className="text-gray-500">CTR</div>
                  <div className="font-semibold text-indigo-600">{headline.metrics.ctr}%</div>
                </div>
                <div>
                  <div className="text-gray-500">SEO</div>
                  <div className="font-semibold text-indigo-600">{headline.metrics.seo}/10</div>
                </div>
              </div>
              <button 
                onClick={() => copyToClipboard(headline.title)}
                className="mt-3 text-indigo-600 hover:text-indigo-700 text-sm font-medium flex items-center gap-1"
              >
                <Share2 className="w-4 h-4" />
                Copy
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}